import React, { useState, useEffect, useContext } from 'react'; // TODO: remove useContext
import { useForm } from 'react-hook-form';
import { withRouter } from 'react-router-dom';

import { useQuery, useMutation } from '../hooks/graph';
import { SetupContext } from '../contexts/setup';
import { AuthContext } from '../contexts/auth';
import Icon from '../components/icon';
import Spinner from '../components/spinner';
import { formControlInvalid } from '../components/forms';
import { setClipboard, enableTooltips } from '../utils/misc';

import MeConnectorCreate from './me-connector-create';
import MeConnectorDelete from './me-connector-delete';
import MeConnectorProviderList from './me-connector-provider-list';
import MeConnectorAccountNotifications from './me-connector-account-notifications';
// reserved / import MeConnectorAccountFollowers from './me-connector-account-followers';
import MeConnectorHookDelete from './me-connector-hook-delete';

const getHookUrl = shortKey => window.location.protocol + '//' + window.location.host + '/hook/' + shortKey;
const createdAtTo = Date.now() - 24 * 60 * 60 * 1000; // 24hr
const controller = new AbortController();

function MeConnector({ match }) {
	const { providers } = useContext(SetupContext);
	const { isAdmin } = useContext(AuthContext);

	const [ { data }, refetch ] = useQuery('hooks', controller);
	const [ { data: dataConnectors }, refetchConnectors ] = useQuery('connectors', controller);
	const [ { data: dataActionsOrderCounters } ] = useQuery('actionsOrderCounters', {variables: {
		code: 'Order',
		isGroup: true,
		createdAtTo,
	}}, controller);

	const [ hookCreate, { fetching: fetchingHookCreate } ] = useMutation('hookCreate', controller);
	const [ hookUpdate ] = useMutation('hookUpdate', controller);
	const [ hookDelete ] = useMutation('hookDelete', controller);
	const [ connectorUpdate ] = useMutation('connectorUpdate', controller);
	const { register, handleSubmit, setValue, clearErrors, formState: { errors } } = useForm();

	// TODO looks messy, refactor more
	const [ state, setState ] = useState({
		createItem: null,
		deleteItem: null, // TODO rename to deleteHook?
		updateItem: null,
		updateItemAccount: null,
		dataHooksPerAccounts: null,
	});

	const [ action, setAction ] = useState({action: null, data: null});

	const onConnectorCreateProviderSelect = provider => {
		setAction({type: 'connectorCreate', data: {provider}});
		setState({...state, createConnectorProvider: provider});
	};

	const onSubmitUpdateAccount = values => {
		setState({...state, updateItemAccount: null});

		if (!values.name) { return; }

		const connector = dataConnectors.connectors.find(
			item => item.id === state.updateItemAccount.connectorId);

		const accounts = [...connector.accounts].map(item =>
			item.id === state.updateItemAccount.id ? {...item, name: values.name} : item
		);

		connectorUpdate({
			accounts: JSON.stringify(accounts), id: connector.id,
		}, controller).then(() => {
			refetchConnectors(); // kiss-y overkill
		}).catch(() => {
			// obsoleted / setError('submit', {message: 'Error: ' + err.message}); // temporal message
		});
	};

	const onSubmitHookCreate = values => {
		setState({...state, createItem: values});

		hookCreate({
			...values,
			connectorId: parseInt(values.connectorId),
		}, controller).then(() => {
			refetch();
			// obsoleted / reset();
		}).catch(() => {
			// obsoleted / setError('submit', {message: 'Error: ' + err.message}); // temporal message
		});
	};

	const onSubmitHookUpdate = values => {
		setState({...state, updateItem: null});

		hookUpdate({
			...values, id: state.updateItem.id,
		}, controller).then(() => {
			refetch(); // kiss-y overkill
		}).catch(() => {
			// obsoleted / setError('submit', {message: 'Error: ' + err.message}); // temporal message
		});
	};

	const onSubmitHookDelete = values => {
		hookDelete({
			...values
		}, controller).then(() => {
			refetch(); // kiss-y overkill
		}).catch(() => {
			// obsoleted / setError('submit', {message: 'Error: ' + err.message}); // temporal message
		});
	};

	const getConnectorExample = (connector, account) => {
		const reference = providers[connector.providerName].reference;
		const symbols = reference?.symbol?.examples || [];
		const symbolsClass = reference?.symbol?.examplesClass || [];
		const symbolsBrach = reference?.symbol?.examplesBranch || [];
		const symbolsAccount = reference?.symbol?.examplesAccount || [];

		const symbolIndex = Math.max(symbolsBrach.findIndex(item => item == connector.branch), 0);

		return JSON.stringify({
			...(['future', 'option', 'warrant', 'bond'].includes(symbolsClass[symbolIndex]) ? {class: symbolsClass[symbolIndex]} : {}),
			symbol: (symbols[Math.max(symbolsAccount.indexOf(account), symbolIndex)] || 'AAPL').toUpperCase(), quantity: 1, action: 'buy',
		});
	};

	useEffect(() => {
		const provider = providers[match.params?.providerName];
		providers && setAction({type: 'connectorCreate', data: {provider}});
	}, [match.params?.providerName]);

	useEffect(() => {
		if (!data || !dataConnectors) { return; } // keep it, to prevent rendering sides

		setState({...state,
			dataHooksPerAccounts: dataConnectors.connectors.reduce((accumulator, item) => {
				item.accounts.forEach(itemAcount => {
					accumulator[`${itemAcount.id}@${item.id}`] = data.hooks.
						filter(hook => hook.accountId == itemAcount.id && hook.connector.id == item.id).
						sort((a, b) => a.name > b.name ? 1 : -1);
				});
				return accumulator;
			}, {}),
		});
	}, [data, dataConnectors]);

	useEffect(() => {
		// critical: after rendering of the "toggling" elemenent
		state.dataHooksPerAccounts && enableTooltips();
	}, [!!state.dataHooksPerAccounts]);

	useEffect(() => { state?.updateItem && setValue('name', state.updateItem.name); }, [state?.updateItem]);
	useEffect(() => { state?.updateItemAccount && setValue('name', state.updateItemAccount.name); }, [state?.updateItemAccount]);

	useEffect(() => () => controller.abort(), []); // abort on unmount

	return data && dataConnectors && state.dataHooksPerAccounts ? (
		<div id="connector">
			<div className="d-flex my-3">
				<div><h3 className="pe-5">Brokers &amp;&nbsp;Webhooks</h3></div>

				{
					!!dataConnectors.connectors.length && (
						<div className="ms-auto dropend">
							<button
								type="button"
								className="btn btn-primary dropdown-toggle"
								data-bs-toggle="collapse"
								data-bs-target="#providerList"
								aria-controls="providerList"
								onClick={() => setAction({type: 'connectorCreateProviderSelect'})}
							>
								Connect broker&nbsp;
							</button>
						</div>
					)
				}
			</div>

			<div className={dataConnectors.connectors.length ? 'collapse' : ''} id="providerList" aria-expanded={!!dataConnectors.connectors.length}>
				<MeConnectorProviderList providers={providers} connectors={dataConnectors.connectors} show={!dataConnectors.connectors.length || action.type === 'connectorCreateProviderSelect'} onSubmit={onConnectorCreateProviderSelect} />
			</div>

			{
				dataConnectors.connectors.length ? (
					dataConnectors.connectors.sort((a, b) => a.providerName > b.providerName ? 1 : -1).map(itemConnector => // weak: on render sorting
						providers[itemConnector.providerName] && itemConnector.accounts.sort((a, b) => a.id > b.id ? 1 : -1).map(itemAccount =>
							<div key={itemAccount.id} className="mb-5">
								<table className="table mb-0">
									<tbody>
										<tr>
											<td className="align-bottom">
												<div className="fw-bold">
													{providers[itemConnector.providerName].title} {itemConnector.branch ? '@' + itemConnector.branch : ''}
												</div>

												{
													state.updateItemAccount?.connectorId === itemConnector.id && state.updateItemAccount?.id === itemAccount.id ?
														<div><form onSubmit={handleSubmit(onSubmitUpdateAccount)}><input {...register('name', {required: 'Required'})} type="text" id="name" placeholder="Name" className={formControlInvalid(errors?.name, 'form-control form-control-sm d-inline w-auto me-2')} /><button type="submit" className="btn btn-sm btn-outline-primary me-2">Save</button><button type="button" onClick={() => { setState({...state, updateItemAccount: null}); }} className="btn btn-sm btn-outline-secondary">Cancel</button></form></div>
														:
														itemAccount.id && (() => {
															const title = itemAccount.dataTitle || itemAccount.id;
															const titleSuffix = [itemAccount.name, itemAccount.dataType, itemAccount.dataCurrency].filter(item => !!item).join(', ');

															return (
																<div className="hover text-nowrap">
																	{`Account\u00A0${title ? '#' + title : ''}`} <span className="text-capitalize text-wrap">{titleSuffix ? `(${titleSuffix})` : ''}</span>
																	{ itemConnector.isDemo || itemAccount.demo ? <span className="badge bg-secondary ms-1">Demo</span> : false }
																	<span className="hover-opacity-100 opacity-0 ps-2"><a href="#" onClick={() => { event.preventDefault(); clearErrors(); setState({...state, updateItem: null, updateItemAccount: {id: itemAccount.id, name: itemAccount.name, connectorId: itemConnector.id}}); }}>Edit</a></span>
																</div>
															);
														})()
												}
											</td>
											<td className="align-bottom">
												<div className="d-flex justify-content-end">
													<div className="dropdown dropdown-menu-end">
														<button
															className="btn btn-outline-primary btn-sm dropdown-toggle"
															type="button"
															data-bs-toggle="dropdown"
														>
															Settings
														</button>

														<ul className="dropdown-menu">
															{ isAdmin && <li><button className="dropdown-item" data-bs-toggle="modal" data-bs-target="#connectorAccountNotificationsModal" onClick={() => setAction({type: 'connectorAccountSetNotifications', data: {connector: itemConnector, account: itemAccount}})}>Notifications</button></li> }
															{ isAdmin && <li><button className="dropdown-item text-muted">Followers <span className="badge rounded-pill text-bg-secondary">3</span></button></li> }
															{ isAdmin && <li><hr className="dropdown-divider" /></li> }
															<li><button className="dropdown-item" data-bs-toggle="modal" data-bs-target="#connectorCreateModal" onClick={() => setAction({type: 'connectorCreate', data: {provider: providers[itemConnector.providerName]}})}>Reconnect</button></li>
															<li><button className="dropdown-item" data-bs-toggle="modal" data-bs-target="#connectorDeleteModal" onClick={() => setAction({type: 'connectorDelete', data: {connector: itemConnector}})}>Delete</button></li>
														</ul>
													</div>
												</div>
											</td>
										</tr>
									</tbody>
								</table>

								<table className="table table-light rounded rounded-3 overflow-hidden">
									{/* reserved
										!providers[itemConnector.providerName].status && (
											<tbody>
												<tr>
													<td colSpan="2" className="bg-warning text-center">
														The platform is disabled. Any calls to the hooks are be forbidden.
													</td>
												</tr>
											</tbody>
										)
									*/}

									{
										itemConnector.providerName === 'tda' && (
											<tbody>
												<tr>
													<td colSpan="2" className="bg-warning">
														As you know, TD Ameritrade and Schwab are merging. As part of their merger, they will be disabling all third party access to the TD Ameritrade API. You should have received a notification from them. At this time, your webhooks will stop working. We will connect to the new Schwab API as soon as we are given access to it. Sorry for any inconvenience this may cause. If you wish to continue auto trading, please consider opening an account at a supported broker.
													</td>
												</tr>
											</tbody>
										)
									}

									{
										itemConnector.providerName === 'xtb' && (
											<tbody>
												<tr>
													<td colSpan="2" className="bg-warning text-center">
														XTB no longer offers auto trading. As of March 14, 2025, the XTB API service via the hosts xapi.xtb.com and ws.xtb.com has been disabled. <a href="https://www.xtb.com/int/help-center/our-platforms-1/do-you-offer-api-1">More</a>.
													</td>
												</tr>
											</tbody>
										)
									}

									{
										itemConnector.isActive && (

											// nb. keep +1 day, to not to be "behind" the backend condition (see Math.floor...)
											(itemConnector.expiresAt && parseInt(itemConnector.expiresAt) < Date.now() + (['schwab'].includes(itemConnector.providerName) ? 2 + 1 : 5 + 1) * 24 * 3600 * 1000) && (
												<tbody>
													<tr>
														<td colSpan="2" className="bg-warning text-center">
															The connection is {parseInt(itemConnector.expiresAt) < Date.now() ? 'expired' : 'about to expire soon'}, please
															<div>
																<button type="button" className="btn btn-outline-primary btn-sm" data-bs-toggle="modal" data-bs-target="#connectorCreateModal"
																	onClick={() => setAction({type: 'connectorCreate', data: {provider: providers[itemConnector.providerName]}})}
																>
																	Reconnect
																</button>
															</div>
														</td>
													</tr>
												</tbody>
											)
										)
									}

									{
										!itemConnector.isActive && (
											<tbody>
												<tr>
													<td colSpan="2" className="bg-warning text-center">
														The connection is inactive due to connection or authorization issues.
														Try manually to
														<div>
															<button type="button" className="btn btn-sm btn-outline-primary my-1" data-bs-toggle="modal" data-bs-target="#connectorCreateModal"
																onClick={() => setAction({type: 'connectorCreate', data: {provider: providers[itemConnector.providerName]}})}
															>
																Reconnect
															</button>
														</div>
													</td>
												</tr>
											</tbody>
										)
									}

									{
										state.dataHooksPerAccounts?.[
											`${itemAccount.id}@${itemConnector.id}`
										]?.length > 0 && (
											<tbody>
												{
													state.dataHooksPerAccounts[
														`${itemAccount.id}@${itemConnector.id}`
													].map(item =>
														<tr key={item.id + item.name}>
															<td>
																{
																	state.updateItem?.id === item.id ?
																		<div><form onSubmit={handleSubmit(onSubmitHookUpdate)}><input {...register('name', {required: 'Required'})} type="text" id="name" placeholder="Name" className={formControlInvalid(errors?.name, 'form-control form-control-sm d-inline w-auto me-2')} /><button type="submit" className="btn btn-sm btn-outline-primary me-2">Save</button><button type="button" onClick={() => { setState({...state, updateItem: null}); }} className="btn btn-sm btn-outline-secondary">Cancel</button></form></div>
																		:
																		<div className="hover text-nowrap">{item.name || 'Noname'} {item.isTest ? <span className="badge bg-secondary">Test</span> : false} <span className="hover-opacity-100 opacity-0 ps-2"><a href="#" onClick={() => { event.preventDefault(); clearErrors(); setState({...state, updateItem: item, updateItemAccount: null}); }}>Edit</a></span></div>
																}
																<div role="button" onClick={() => setClipboard(getHookUrl(item.shortKey))} className="hover text-nowrap">{getHookUrl(item.shortKey)}<span className="hover-opacity-100 opacity-25 ps-2" data-bs-toggle="tooltip" data-bs-title="Copy to clipboard"><Icon.Copy /></span></div>

																{
																	!item.isActive && (
																		<div className="text-danger">Deactivated due to account disconnection or multiple invalid requests</div>
																	)
																}

																{
																	[dataActionsOrderCounters?.actionsOrderCounters.
																		find(itemCounter => itemCounter.hookShortKey == item.shortKey)?.counter
																	].map(counter => counter &&
																		<div key="counter" className="text-secondary">
																			<small>{counter} signals in the&nbsp;last&nbsp;24h</small>
																		</div>
																	)
																}

																<div className="d-block d-md-none">
																	<a
																		href="#"
																		onClick={event => { event.preventDefault(); item.isTest ? onSubmitHookDelete({id: item.id}) : setState({...state, deleteItem: item}); }}
																		className="text-decoration-none text-secondary"
																		role="button"
																		data-bs-toggle={item.isTest ? '' : 'modal'}
																		data-bs-target="#connectorHookDeleteModal"
																	>
																		<Icon.Trash />
																	</a>
																</div>
															</td>
															<td align="right" className="d-none d-md-table-cell">
																<a
																	href="#"
																	onClick={event => { event.preventDefault(); item.isTest ? onSubmitHookDelete({id: item.id}) : setState({...state, deleteItem: item}); }}
																	className="text-decoration-none text-secondary"
																	role="button"
																	data-bs-toggle={item.isTest ? '' : 'modal'}
																	data-bs-target="#connectorHookDeleteModal"
																>
																	<Icon.Trash />
																</a>
															</td>
														</tr>
													)
												}
												{
													state.dataHooksPerAccounts[
														`${itemAccount.id}@${itemConnector.id}`
													]?.length && (
														<tr>
															<td role="button" onClick={() => setClipboard(getConnectorExample(itemConnector), itemAccount.id)} className="hover">
																<div>Example request:</div><div><code className="alert alert-primary d-inline-block p-1 mb-0">{getConnectorExample(itemConnector, itemAccount.id)}</code><span className="hover-opacity-100 opacity-25 ps-2" data-bs-toggle="tooltip" data-bs-title="Copy to clipboard"><Icon.Copy /></span></div>
																<div className="d-block d-md-none mt-1"><a href={'/me/documentation/' + itemConnector.providerName} role="button" className="text-decoration-none">Webhook Docs</a></div>
															</td>
															<td align="right" className="d-none d-md-table-cell"><a href={'/me/documentation/' + itemConnector.providerName} role="button" className="text-decoration-none">Webhook Docs</a></td>
														</tr>
													)
												}
											</tbody>
										)
									}

									<tbody>
										<tr className="bg-light">
											<td colSpan="2">
												<button
													onClick={() => {
														!fetchingHookCreate && onSubmitHookCreate({
															name: 'Hook',
															connectorId: itemConnector.id,
															accountId: itemAccount.id,
														});
													}}
													className="btn btn-primary btn-sm my-1"
													type="button"
												>
													<Spinner
														show={fetchingHookCreate &&
															!state.createItem?.isTest &&
															state.createItem?.connectorId == itemConnector.id &&
															state.createItem?.accountId == itemAccount.id}
														delay={0}
													>Create webhook</Spinner>
												</button>

												<button
													onClick={() => {
														!fetchingHookCreate && onSubmitHookCreate({
															name: 'Hook',
															connectorId: itemConnector.id,
															accountId: itemAccount.id,
															isTest: true,
														});
													}}
													className="btn btn-outline-secondary btn-sm my-1 ms-2"
													type="button"
												>
													<Spinner
														show={fetchingHookCreate &&
															state.createItem?.isTest &&
															state.createItem?.connectorId == itemConnector.id &&
															state.createItem?.accountId == itemAccount.id}
														delay={0}
													>Create test webhook</Spinner>
												</button>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						)
					)
				) : false
			}

			<MeConnectorCreate provider={action.type === 'connectorCreate' && action.data.provider} />

			<MeConnectorDelete providers={providers} hooks={data.hooks} connector={action.type === 'connectorDelete' && action.data.connector} onSuccess={() => { refetch(); refetchConnectors(); }} />

			<MeConnectorAccountNotifications connector={action.type === 'connectorAccountSetNotifications' && action.data.connector} account={action.type === 'connectorAccountSetNotifications' && action.data.account} />
			{/* <MeConnectorAccountFollowers connector={action.type === 'connectorAccountSetFollowers' && action.data.connector} account={action.type === 'connectorAccountSetFollowers' && action.data.account} /> */}

			<MeConnectorHookDelete hook={state.deleteItem} getHookUrl={getHookUrl} onSuccess={() => { refetch(); }} />
		</div>
	) : false;
}

export default withRouter(MeConnector);
